export default __webpack_public_path__ + "static/media/143-envelope.48892151.svg";